import React, {useEffect, useState} from "react";
import {
    Button,
    Card,
    Checkbox,
    Col,
    Container,
    DatePicker,
    Divider,
    Icon,
    Row,
    Select,
    Textarea,
    TextInput,
    Tab,
    Tabs,
} from "react-materialize";
import axios from "axios";
import {axiosClient, setUserTimezoneInRequest} from "../api/httpClient";
import {connect} from "react-redux";
import {
    EMAIL_REGEX,
    errorToast,
    infoToast,
    isCustomer,
    modifiedOrNull,
    parseSqlDateTime,
    resize,
    successToast,
    toISODate,
    uploadMedia,
    warningToast,
    deleteSpacesObjectByPublicUrl,
} from "../api/Util";
import { clearRefThumbnailCommon } from "../helpers/refThumbnailHelper";
import * as _ from "lodash";
import * as actions from "../actions";
import {randomNumber} from "react-ratings-declarative/build/utils";
import DEFAULT_IMAGE from "./img/default-img.jpg";
import BillingTable from "./common/BillingTable/BillingTable";

import {Prompt} from 'react-router-dom';
import { MdErrorOutline } from "react-icons/md";
import { CARD_COMMENT_EMAIL, CARD_COMMENT_TAG_EMAIL, CARD_MOVEMENT_EMAIL, INITIAL_EMAIL_PREFERENCES_STATE, TIMEZONE_LIST } from "../api/Constants";
import ChangePassword from "./Password/ChangePassword";

const INITIAL_STATE = {
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    dropboxEmail: "",
    referral: "Other",
    otherReferral: "",
    videoType: "",
    aboutVideo: "",
    socialMediaLink: "",
    videoStyle: "",
    videoInspired: "",
    videoInfo: "",
    additionalVideoInfo: "",
    billingDate: new Date(0),
    billingData: [],
    preferredEditingSoftware: "",
    userProfile: {},
    
    channelName:"",
    prevThumbnailsLink:[""],
    refThumbnailsFile:"",
    thumbnailFont:"",
    thumbnailMainColor:"",
    thumbnailSubColor:"",
    descriptionLink:[""],
    photoPreference:"",
    textPreference:"",
    titlePreference:"",
    endCardPreference:"",
    publicVideo:"",
    keywordList:"",
    additionalThumbnailData:"",
    SelectedUserId: "",
};

const INITIAL_STATE_FOR_TEST = {
    firstName: null,
    lastName: null,
    email: null,
    secondaryEmail: null,
    dropboxEmail: null,
    referral: null,
    otherReferral: null,
    videoType: null,
    aboutVideo: null,
    socialMediaLink: null,
    videoStyle: null,
    videoInspired: null,
    videoInfo: null,
    additionalVideoInfo: null,
    billingDate: null,
    billingData: [],
    preferredEditingSoftware: null,
    timezone: "",
    channelName:null,
    prevThumbnailsLink:null,
    refThumbnailsFile:null,
    thumbnailFont:null,
    thumbnailMainColor:null,
    thumbnailSubColor:null,
    descriptionLink:null,
    photoPreference:null,
    textPreference:null,
    titlePreference:null,
    endCardPreference:null,
    publicVideo:null,
    keywordList:null,
    additionalThumbnailData:null,
};

export default connect(mapStateToProps, actions)((props) => {

    const loggedInUser = props?.auth?.loggedInUser || {};
    const customer = isCustomer(loggedInUser);
    const incompleteProfile = !loggedInUser.is_profile_completed;
    const [state, setState] = useState(INITIAL_STATE);
    const [updateDisabled, setUpdateDisabled] = useState(false);
    const [profileImage, setProfileImage] = useState(null);

    const [selectedFile, setSelectedFile] = useState(null);
    const [showThumbnailsPre, setShowThumbnailsPre] = useState(false);
    const [activeTab, setActiveTab] = useState('BASIC INFO');

    const [changedData, setChangedData] = useState(INITIAL_STATE_FOR_TEST);

    let showYtField = false;
    if(customer && loggedInUser.has_youtube_helper && loggedInUser.is_yt_fields_filled)
    {
        showYtField = true;
    }
    
    const refreshUser = () => {
        infoToast("Loading");
        setChangedData(INITIAL_STATE_FOR_TEST);
        const cancelToken = axios.CancelToken.source();
        axiosClient.get('/api/user/' + loggedInUser.client_id, {cancelToken: cancelToken.token})
            .then(({data}) => {
                setState(prev => ({
                    ...prev,
                    firstName: data.firstname,
                    lastName: data.lastname,
                    email: data.useremail,
                    secondaryEmail: data.secondary_email || prev.secondaryEmail,
                    dropboxEmail: data.dropbox_email || prev.dropboxEmail,
                    referral: data.referral || prev.referral,
                    otherReferral: data.otherreferral || prev.otherReferral,
                    videoType: data.video_type || prev.videoType,
                    aboutVideo: data.about_video || prev.aboutVideo,
                    socialMediaLink: data.social_media_link || prev.socialMediaLink,
                    videoStyle: data.video_style || prev.videoStyle,
                    videoInspired: data.video_inspired || prev.videoInspired,
                    videoInfo: data.video_info || prev.videoInfo,
                    additionalVideoInfo: data.additional_video_info || prev.additionalVideoInfo,
                    billingDate: parseSqlDateTime(data.billing_date),
                    billingData: data.billing_data,
                    preferredEditingSoftware: data.preferred_editing_software || "",
                    timezone: data.timezone || "",
                    // for yt helper fields data
                    channelName: data.channel_name || prev.channelName,
                    prevThumbnailsLink: 
                    data.prev_thumbnails_link && data.prev_thumbnails_link !== "" ? data.prev_thumbnails_link.split('|'):[""] ,
                        // || prev.prevThumbnailsLink.split(','),
                    refThumbnailsFile: data.ref_thumbnails_file || prev.refThumbnailsFile,
                    thumbnailFont: data.thumbnail_font || prev.thumbnailFont,
                    thumbnailMainColor: data.thumbnail_main_color || prev.thumbnailMainColor,
                    thumbnailSubColor: data.thumbnail_sub_color || prev.videoInspired,
                    descriptionLink: data.description_link && data.description_link !== "" ? data.description_link.split('|'):[""] ,
                        // || prev.descriptionLink.split(','),
                    photoPreference: data.photo_preference || prev.photoPreference,
                    textPreference: data.text_preference || prev.textPreference,
                    titlePreference: data.title_preference || prev.titlePreference,
                    endCardPreference: data.end_card_preference || prev.endCardPreference,
                    publicVideo: data.public_video || prev.publicVideo,
                    keywordList:data.keyword_list || prev.keywordList,
                    additionalThumbnailData:data.additional_thumbnail_data || prev.additionalThumbnailData,
                    SelectedUserId: data?.client_id,
                    userProfile: data
                }));
                setProfileImage(data.profile_img);
                setState(prev => ({...prev, preferredEditingSoftware: data.preferred_editing_software || ""}));
                if(data.ref_thumbnails_file && data.ref_thumbnails_file !== "")
                {
                    setShowThumbnailsPre(true);
                }
                if (data.mailPreferences) {
                    setState(prev => ({...prev, mailPreferences: data.mailPreferences}));
                }
            }).catch(err => {
                if (!axios.isCancel(err)) {
                    errorToast("Something went wrong");
                    console.error(err);
                }
            });

        return cancelToken;
    };

    useEffect(() => {
        const cancelToken = refreshUser();

        return () => cancelToken.cancel("Page closed");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInUser, customer, incompleteProfile]);

    useEffect(() => {
        if(Object.keys(changedData).find(key => changedData[key] === 1)?true:false)
        {
            window.onbeforeunload = (event) => {
                const e = event || window.event;
                // Cancel the event
                e.preventDefault();
                if (e) {
                  e.returnValue = "There are unsaved changes. Are you sure want to leave this page?"; // Legacy method for cross browser support
                }
                return "There are unsaved changes. Are you sure want to leave this page?"; // Legacy method for cross browser support
              };
        }
        else{
            window.onbeforeunload = (event) => {
                // eslint-disable-next-line no-unused-vars
                const e = event || window.event;
                // Cancel the event
                // e.preventDefault();
            }
        }
    }, [changedData]);
    
    useEffect(() => {
        return ()=>{
            window.onbeforeunload = (event) => {
                // eslint-disable-next-line no-unused-vars
                const e = event || window.event;
                // Cancel the event
                // e.preventDefault();
            }
        }
    }, [])

    useEffect(() => {
        if(showYtField && loggedInUser.is_yt_fields_filled === 1 && document.getElementById("yt-helper-field")){
            var elmnt = document.getElementById("yt-helper-field");
            elmnt.scrollIntoView();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function onClickUpdate() {

        if(incompleteProfile && !state.dropboxEmail)
        {
            return infoToast("Please fill the required Gdrive or Dropbox Email field ");
        }
        if(incompleteProfile && state.dropboxEmail && !EMAIL_REGEX.test(state.dropboxEmail))
        {
            return infoToast("Please fill the valid Gdrive or Dropbox Email address in the field");
        }
        if(!customer && showYtField && (state.channelName ==="" || state.thumbnailFont ==="" || state.thumbnailMainColor === "" || state.descriptionLink[0] ==="" || state.photoPreference ==="" )){
            if(state.channelName === "") {
                document.getElementById('channelName-error-msg').classList.remove("error-hidden");
                document.getElementById('channelName-error-msg').classList.add("show-error");
            }
            if(state.thumbnailFont ==="") {
                document.getElementById('thumbnailFont-error-msg').classList.remove("error-hidden");
                document.getElementById('thumbnailFont-error-msg').classList.add("show-error");
            }
            if(state.thumbnailMainColor === "") {
                document.getElementById('thumbnailMainColor-error-msg').classList.remove("error-hidden");
                document.getElementById('thumbnailMainColor-error-msg').classList.add("show-error");
            }
            if(state.descriptionLink[0] === "") {
                document.getElementById('descriptionLink-error-msg').classList.remove("error-hidden");
                document.getElementById('descriptionLink-error-msg').classList.add("show-error");
            }
            if(state.photoPreference === "") {
                document.getElementById('photoPreference-error-msg').classList.remove("error-hidden");
                document.getElementById('photoPreference-error-msg').classList.add("show-error");
            }
            return warningToast("Please fill the required field");
        }

        const oldAvatar = state.userProfile.profile_img || "";
        let avatarUrlToSave = null;
        let shouldUpdateAvatar = false;
        let shouldDeleteOldAvatar = false;

        try {
            if (!profileImage && oldAvatar) {
                shouldUpdateAvatar = true;
                avatarUrlToSave = "";
                shouldDeleteOldAvatar = true;
            } else if (profileImage && profileImage !== oldAvatar) {
                shouldUpdateAvatar = true;
                const uploadedUrl = await fetch(profileImage)
                    .then(r => r.blob())
                    .then(blob => uploadMedia(blob, loggedInUser.client_id, undefined, "media/profileImage"));
                avatarUrlToSave = uploadedUrl || "";
                shouldDeleteOldAvatar = Boolean(oldAvatar);
            }

            if (shouldDeleteOldAvatar && oldAvatar) {
                deleteSpacesObjectByPublicUrl(oldAvatar);
            }
        } catch (avatarErr) {
            console.error(avatarErr);
            errorToast("Something went wrong while updating avatar");
        }

        setUpdateDisabled(true);
        let data = {
            firstname: modifiedOrNull(state.firstName, state.userProfile.firstname),
            lastname: modifiedOrNull(state.lastName, state.userProfile.lastname),
            email: modifiedOrNull(state.email, state.userProfile.useremail),
            secondary_email: modifiedOrNull(state.secondaryEmail, state.userProfile.secondary_email),
            dropbox_email: modifiedOrNull(state.dropboxEmail, state.userProfile.dropbox_email),
            referral: modifiedOrNull(state.referral, state.userProfile.referral),
            otherreferral: modifiedOrNull(state.otherReferral, state.userProfile.otherreferral) || state.userProfile.otherreferral,
            video_type: modifiedOrNull(state.videoType, state.userProfile.video_type),
            about_video: modifiedOrNull(state.aboutVideo, state.userProfile.about_video),
            social_media_link: modifiedOrNull(state.socialMediaLink, state.userProfile.social_media_link),
            video_style: modifiedOrNull(state.videoStyle, state.userProfile.video_style),
            video_inspired: modifiedOrNull(state.videoInspired, state.userProfile.video_inspired),
            video_info: modifiedOrNull(state.videoInfo, state.userProfile.video_info),
            additional_video_info: modifiedOrNull(state.additionalVideoInfo, state.userProfile.additional_video_info),
            billing_date: modifiedOrNull(toISODate(state.billingDate), state.userProfile.billing_date),
            preferred_editing_software: modifiedOrNull(state.preferredEditingSoftware, state.userProfile.preferred_editing_software),
            timezone: modifiedOrNull(state.timezone, state.userProfile.timezone),

            // for yt helper fields data
            channel_name: modifiedOrNull(state.channelName, state.userProfile.channel_name),
            prev_thumbnails_link: modifiedOrNull(state.prevThumbnailsLink, state.userProfile.prev_thumbnails_link),
            ref_thumbnails_file: modifiedOrNull(state.refThumbnailsFile, state.userProfile.ref_thumbnails_file),
            thumbnail_font: modifiedOrNull(state.thumbnailFont, state.userProfile.thumbnail_font),
            thumbnail_main_color: modifiedOrNull(state.thumbnailMainColor, state.userProfile.thumbnail_main_color),
            thumbnail_sub_color: modifiedOrNull(state.thumbnailSubColor, state.userProfile.thumbnail_sub_color),
            description_link: modifiedOrNull(state.descriptionLink, state.userProfile.description_link),
            photo_preference: modifiedOrNull(state.photoPreference, state.userProfile.photo_preference),
            text_preference: modifiedOrNull(state.textPreference, state.userProfile.text_preference),
            title_preference: modifiedOrNull(state.titlePreference, state.userProfile.title_preference),
            end_card_preference: modifiedOrNull(state.endCardPreference, state.userProfile.end_card_preference),
            public_video: modifiedOrNull(state.publicVideo, state.userProfile.public_video),
            keyword_list:modifiedOrNull(state.keywordList, state.userProfile.keyword_list),
            additional_thumbnail_data:modifiedOrNull(state.additionalThumbnailData, state.userProfile.additional_thumbnail_data),
        };

        if (state.mailPreferences) {
            data = {...data, mailPreferences: state.mailPreferences};
        }

        data = _.pickBy(data, _.identity);

        if (shouldUpdateAvatar) {
            data = { ...data, profile_img: avatarUrlToSave };
        }

        setChangedData(INITIAL_STATE_FOR_TEST);

        axiosClient.post('/api/user/profile', data).then(({data}) => {
            let timezone = modifiedOrNull(state.timezone, state.userProfile.timezone)
            if (timezone) {
                localStorage.setItem("timezone", timezone);
            }
            setUserTimezoneInRequest();
            successToast(data.message || "Profile updated successfully");

            localStorage.removeItem("skipProfileForNow");

            if(incompleteProfile || loggedInUser.is_yt_fields_filled === 1) {
                props.fetchUser();
                setTimeout(props.history.push("/"), 1000);
            }
        }).catch(err => {
            errorToast("Unable to update profile");
            console.error(err);
        }).finally(() => {
            setUpdateDisabled(false);
            props.history.push('/');
        });
    }

    function onChange(e) {
        let name = e.target.name;
        let value = e.target.value;

        let tem = "";
        let temValue = value === "" ? (name==="otherReferral"?"":null):value;

        switch(name)
        {
            case "firstName": tem = "firstname";  break;
            case "lastName": tem = "lastname";  break;
            case "email": tem = "useremail";  break;
            case "secondaryEmail": tem = "secondary_email";  break;
            case "dropboxEmail": tem = "dropbox_email";  break;
            case "referral": tem = "referral";  break;
            case "otherReferral": tem = "otherreferral";  break;
            case "videoType": tem = "video_type";  break;
            case "aboutVideo": tem = "about_video";  break;
            case "socialMediaLink": tem = "social_media_link";  break;
            case "videoStyle": tem = "video_style";  break;
            case "videoInspired": tem = "video_inspired";  break;
            case "videoInfo": tem = "video_info";  break;
            case "additionalVideoInfo": tem = "additional_video_info";  break;
            case "billingDate": tem = "billing_date";  break;
            case "preferredEditingSoftware": tem = "preferred_editing_software"; break;
            
            case "channelName": tem = "channel_name";  break;
            case "prevThumbnailsLink": tem = "prev_thumbnails_link";  break;
            case "refThumbnailsFile": tem = "ref_thumbnails_file";  break;
            case "thumbnailFont": tem = "thumbnail_font";  break;
            case "thumbnailMainColor": tem = "thumbnail_main_color";  break;
            case "thumbnailSubColor": tem = "thumbnail_sub_color";  break;
            case "descriptionLink": tem = "description_link";  break;
            case "photoPreference": tem = "photo_preference";  break;
            case "textPreference": tem = "text_preference";  break;
            case "titlePreference": tem = "title_preference";  break;
            case "endCardPreference": tem = "end_card_preference";  break;
            case "publicVideo": tem = "public_video";  break;
            case "keywordList": tem = "keyword_list";  break;
            case "additionalThumbnailData": tem = "additional_thumbnail_data";  break;
            default:
                break;
        }

        setChangedData(prev => ({...prev,[name]:null}));
        if (state.userProfile[tem] !== temValue) {
            setChangedData(prev => ({ ...prev, [name]: 1 }));
        } else if (state.userProfile[tem] === temValue && changedData[name]) {
            setChangedData(prev => ({ ...prev, [name]: null }));
        }    

        setState(prev => ({...prev, [name]: value}));
        let ele = document.getElementById(`${name}-error-msg`);
        if(ele && ele.classList === "show-error") {
            ele.classList.remove("show-error");
            ele.classList.add("error-hidden");
        }
    }

    function onEmailPreferencesChange(e) {
        const {name} = e.target;
        let mailPreferences = state.mailPreferences ? state.mailPreferences : INITIAL_EMAIL_PREFERENCES_STATE;
        mailPreferences[name] = mailPreferences[name] === 1 ? 0:1;
        setState(prev => ({...prev, mailPreferences}));
    }

    function clearProfileImage() {
        setProfileImage(null);
    }

    function updateProfileImage() {
        infoToast("Avatar changes will be saved when you click Update.");
    }

    function makeLinks(name, value, onRemove) {
        if(value.length)
        {
        let links = Array(value.length - 1);
        for(let id = 1; id < value.length; id++) {
            links[id-1] = (
                <TextInput key={`txt_${name}-${id}`} s={12} name={name} type="url" validate onChange={e => onChangeLinks(e, id)} value={value[id]}
                   icon={<Button style={{marginRight: "10px"}} className="btn-danger" onClick={() => onRemove(id)}><Icon>remove</Icon></Button>} />
            );
        }
        return links;
    }
    }

    function removePrevThumbnailsLink(id) {
        let list = state.prevThumbnailsLink;
        list.splice(id, 1);
        setState(prev => ({...prev, prevThumbnailsLink: list}));
    }
    
    function removeDescriptionLink(id) {
        let list = state.descriptionLink;
        list.splice(id, 1);
        setState(prev => ({...prev, descriptionLink: list}));
    }

    function onChangeLinks(e, index) {
        let name = e.target.name;
        let value = e.target.value;
        
        if(index !== null && index >= 0) {
            let list = state[name];
            list = resize(list, index, "");
            list[index] = value;
            setState(prevState => ({...prevState, [name]: list}));
        }

        let ele = document.getElementById(`${name}-error-msg`);
        if(ele && ele.classList === "show-error") {
            ele.classList.remove("show-error");
            ele.classList.add("error-hidden");
        }
    }

    function addPrevThumbnailsLink() {
        setState(prev => ({...prev, prevThumbnailsLink: [...prev.prevThumbnailsLink, ""]}));
    }
    function addDescriptionLink() {
        setState(prev => ({...prev, descriptionLink: [...prev.descriptionLink, ""]}));
    }
    async function uploadFile() {
        try {
            if (selectedFile) {
                
                let url = null;
                const progressBar = infoToast("Uploading file, please wait", 0);
                
                if (state.refThumbnailsFile && state.refThumbnailsFile !== "") {
                    deleteSpacesObjectByPublicUrl(state.refThumbnailsFile);
                }
            
                url = await fetch(selectedFile)
                    .then(r => r.blob())
                    .then(blob => uploadMedia(blob, loggedInUser.client_id, progressBar, "media/refThumbnail"));                // eslint-disable-next-line no-useless-computed-key
                setState(prev => ({...prev, ["refThumbnailsFile"]: url}));

                await axiosClient.post('/api/user/uploadThumbnailFile', {
                    ref_thumbnails_file: url || '',
                    client_id:loggedInUser.client_id
                });

                successToast("File updated successfully");
                setShowThumbnailsPre(true);
                setSelectedFile(null);
            }
        } catch(err) {
            console.error(err);
            errorToast("Something went wrong in uploading");
        }
    }

    async function clearRefThumbnail() {
        await clearRefThumbnailCommon({
            refThumbnailsFile: state.refThumbnailsFile,
            clientId: loggedInUser.client_id,
            setState,
            setSelectedFile,
            setShowThumbnailsPre,
            clearPreviewOnEmpty: true,
        });
    }

    function handleSkipForNowBtn() {
        localStorage.setItem("skipProfileForNow",true);
        props.history.push('/');     
    }

    function handleActiveTab() {
        const tag = document.getElementsByClassName('active')[1]?.innerText;
        setActiveTab(tag);
    }

    return (
        <Card className="profile-cover"
            title={incompleteProfile ? "Complete your registration" :  "Your Profile"}
            actions={activeTab === "BASIC INFO" ? [
                <Button key="refresh-btn" onClick={refreshUser} node="button" waves="green" large flat>
                    Reload <Icon right>refresh</Icon>
                </Button>,
                // Removed || !validated() so that update button does not depend on set password or not 
                <Button key="update-btn" onClick={() => onClickUpdate()} disabled={updateDisabled}
                        node="button" waves="green" className="btn-primary" large>
                    Update <Icon right>save</Icon>
                </Button>,
                showYtField && !incompleteProfile ?
                <Button key="skip-for-now-btn" onClick={() => handleSkipForNowBtn()}
                        node="button" waves="green" className="btn-primary" large>
                    Skip
                </Button> : null
            ] : null}
        >
            <Tabs className="user-tabs" options={{ responsiveThreshold: Infinity }} onChange={(e) => handleActiveTab(e.target)}>
                <Tab title="Basic Info">
                    <Container id="customer-tabs-container">
                        <Prompt 
                            when={Object.keys(changedData).find(key => changedData[key] === 1)?true:false}
                            message={()=>"Changes that you made may not be saved."}>
                        </Prompt>
                        <Row>
                            <Col>
                                <div className="profile-box">
                                    <div className="left-box">
                                    <label htmlFor="file-input">
                                        <img src={profileImage || DEFAULT_IMAGE} alt="Avatar" style={{width: "100%", height: "auto", cursor: "pointer"}}/>
                                    </label>
                                    <input id="file-input" type="file" style={{display: "none"}} accept="image/*" onChange={e => setProfileImage(URL.createObjectURL(e.target.files[0]))}/>
                                    
                                    <Button onClick={clearProfileImage} icon={<Icon left>clear</Icon>} style={{width: "150px"}} className="btn-danger"
                                        tooltip="Clear current avatar">Clear</Button>
                                <Button onClick={updateProfileImage} icon={<Icon left>save</Icon>} style={{width: "150px"}} className="btn-primary"
                                        tooltip="Save image as avatar">Set Avatar</Button>
                                    
                                    </div>
                                    <div className="right-box custom-input-profile">
                            {
                                customer ?
                                    <DatePicker s={12} m={6}
                                                disabled={true}
                                                options={{
                                                    format: "yyyy-mm-dd",
                                                    defaultDate: state.billingDate,
                                                    setDefaultDate: true
                                                }}
                                    /> : null
                            }
                            <TextInput s={12} m={6}
                                    id={randomNumber()}
                                    name="firstName"
                                    label="First Name *"
                                    value={state.firstName}
                                    onChange={onChange}
                            />
                            <TextInput s={12} m={6}
                                    id={randomNumber()}
                                    name="lastName"
                                    label="Last Name *"
                                    value={state.lastName}
                                    onChange={onChange}
                            />
                            <TextInput s={12} m={6}
                                    id={randomNumber()}
                                    email validate
                                    name="email"
                                    label="Your account login email (primary)? *"
                                    value={state.email}
                                    onChange={onChange}
                            />
                            <TextInput s={12} m={6}
                                    id={randomNumber()}
                                    email validate
                                    name="secondaryEmail"
                                    label="Any assistant's email address?"
                                    value={state.secondaryEmail}
                                    onChange={onChange}
                            />
                            {/* Change from "What is your Dropbox email? *" */}
                            <TextInput s={12} m={6}
                                    id={randomNumber()}
                                    email validate
                                    name="dropboxEmail"
                                    label="What is your Gdrive Email? *"
                                    value={state.dropboxEmail}
                                    onChange={onChange}
                            />
                            <Select s={12} m={6}
                                    id={randomNumber()}
                                    name="timezone"
                                    label="Timezone"
                                    value={state.timezone}
                                    onChange={onChange} >
                                    {
                                        TIMEZONE_LIST.map((item) => (
                                            <option value={item.value}>{item.label}</option>
                                        ))
                                    }
                            </Select>
                            {
                                customer ? React.Children.toArray([
                                    <Textarea s={12} m={6}
                                            id={randomNumber()}
                                            name="socialMediaLink"
                                            label="What is your YouTube channel? What are your active social media accounts?"
                                            value={state.socialMediaLink}
                                            onChange={onChange}
                                    />,
                                    <Textarea s={12} m={6}
                                            id={randomNumber()}
                                            name="additionalVideoInfo"
                                            label="Any other information would you like to give us?"
                                            value={state.additionalVideoInfo}
                                            onChange={onChange}
                                    />,
                                    <Col s={12} m={6} id={randomNumber()}>
                                        {!customer ? <Checkbox disabled={true}
                                                name="subtitles"
                                                label="Subtitles plan"
                                                checked={Boolean(state.userProfile.has_subtitles) || false}
                                                value="1"/> : null
                                        }
                                    </Col>,
                                    <Col s={12} m={6} id={randomNumber()}>
                                        {!customer ? <Checkbox disabled={true}
                                                name="hasYoutubeHelper"
                                                label="Youtube Helper plan"
                                                checked={Boolean(state.userProfile.has_youtube_helper) || false}
                                                value="1"/> : null}
                                    </Col>,
                                    
                                    <Col className="email_preferences_input" style={{ marginTop: '40px', marginBottom: '20px' }}>

                                        <label style={{
                                            fontSize: 'initial',
                                        }} >Email Preferences: </label>
                                        <Checkbox
                                            id={CARD_MOVEMENT_EMAIL + "_checkbox"}
                                            name={CARD_MOVEMENT_EMAIL}
                                            label="Card Movement Email"
                                            onChange={(e) => onEmailPreferencesChange(e)}
                                            checked={Boolean(state.mailPreferences ? state.mailPreferences.card_movement : true)}
                                            value="1" />



                                        <Checkbox
                                            id={CARD_COMMENT_EMAIL + "_checkbox"}
                                            name={CARD_COMMENT_EMAIL}
                                            label="Card Comment Email"
                                            onChange={(e) => onEmailPreferencesChange(e)}
                                            checked={Boolean(state.mailPreferences ? state.mailPreferences.card_comment : true)}
                                            value="1" />

                                        <Checkbox
                                            id={CARD_COMMENT_TAG_EMAIL + "_checkbox"}
                                            name={CARD_COMMENT_TAG_EMAIL}
                                            label="Card Comment Tag Email"
                                            onChange={(e) => onEmailPreferencesChange(e)}
                                            checked={Boolean(state.mailPreferences ? state.mailPreferences.card_comment_tag : true)}
                                            value="1" />
                                    </Col>,

                                ]) : null
                            }
                            {
                                !customer && showYtField ?
                                <Row>
                                    <Divider/>
                                    <Col s={12} id="yt-helper-field" >
                                        <h4>For YouTube Helper</h4>
                                    </Col>
                                    <Col s={12}>
                                        <h6 className="yt-helper-message">Please fill these fields for the YouTube Helper team assist you better.</h6>
                                    </Col>
                                    <Textarea s={12} m={6}
                                        id={randomNumber()}
                                        name="channelName"
                                        label="Is this an existing channel? If so, What is your channel's name? *"
                                        value={state.channelName}
                                        onChange={onChange}>
                                    <div id="channelName-error-msg" className="error-hidden">
                                        <MdErrorOutline style = {{ float : 'left' ,marginTop : '-2px' ,marginRight:'5px'}} size = '25px' />
                                        Channel Name is required
                                    </div>
                                    </Textarea>
                                    <div className="thumbnail_row">
                                    {
                                        !showThumbnailsPre ?
                                        <div className="thumbnails-file-col">
                                            <div className="thumbnails-file-wrap">
                                                <label>
                                                    If you have a file you wish us to see as reference for your thumbnails, please upload here.
                                                </label>
                                                <TextInput 
                                                    type = "file" 
                                                    accept="image/*" 
                                                    onChange = {e => 
                                                        setSelectedFile(URL.createObjectURL(e.target.files[0]))} 
                                                    label="Select File" />
                                                <div className ="thumbnail-prev-btn"> 
                                                <Button onClick={clearRefThumbnail} icon={<Icon left>clear</Icon>}>Cancel</Button>
                                                <Button icon={<Icon left>save</Icon>} style={{ width:'122px' }} onClick={()=>uploadFile()} disabled={!selectedFile}>Save</Button>
                                                </div>
                                            </div>
                                        </div>:null
                                    }
                                    {
                                        showThumbnailsPre ?
                                            <div className="thumbnails-file-col">
                                                <div className="thumbnail-file-wrap">
                                                    <label htmlFor="thumbnails-file-input">
                                                        <img src={selectedFile || state.refThumbnailsFile} alt="" style={{width: "100%", height: "auto", cursor: "pointer"}}/>
                                                    </label>
                                                    <input id="thumbnails-file-input" type="file" style={{display: "none"}} accept="image/*" onChange={e => 
                                                    setSelectedFile(URL.createObjectURL(e.target.files[0]))}/>
                                                    <div className ="thumbnail-prev-btn"> 
                                                        <Button onClick={clearRefThumbnail} icon={<Icon left>clear</Icon>}>Clear</Button>
                                                        <Button icon={<Icon left>save</Icon>} onClick={()=>uploadFile()}>Update</Button>
                                                    </div>
                                                </div>
                                            </div>:null
                                    }
                                    <div className="thumbnails_link_div">
                                        <label>Please provide links to videos that have thumbnails you like so we can refer to them.</label>
                                        <TextInput className="thumbnails_link_add_Btn" s={12} m={6}
                                            icon={<Button className="btn-primary"
                                                            onClick={()=>addPrevThumbnailsLink()}
                                                            ><Icon>add</Icon></Button>}
                                            name="prevThumbnailsLink" type="url" validate 
                                            // label="Please provide links to videos that have thumbnails you like so we can refer to them."
                                            onChange={e => onChangeLinks(e,0)} value={state.prevThumbnailsLink[0]}/>
                                        {makeLinks("prevThumbnailsLink", state.prevThumbnailsLink,removePrevThumbnailsLink )}
                                    </div>
                                    </div>
                                    <div className="yt-photo-preference-div">
                                    <Select
                                            id={randomNumber()}
                                            name="photoPreference"
                                            label="Do you plan on providing us with photos to us or should we take screenshots from your video? *"
                                            value={state.photoPreference}
                                            onChange={onChange} >
                                        <option value="" >Choose an option</option>
                                        <option value="provide_photos">I will provide photos</option>
                                        <option value="take_screenshots">Take screenshots</option>
                                    </Select>
                                    <div id="photoPreference-error-msg" className="error-hidden">
                                        <MdErrorOutline style = {{ float : 'left' ,marginTop : '-2px' ,marginRight:'5px'}} size = '25px' />
                                        Photo Preference is required
                                    </div>
                                    </div>
                                    <Select s={12} m={6}
                                            id={randomNumber()}
                                            name="endCardPreference"
                                            label="Do you need an end card?"
                                            value={state.endCardPreference}
                                            onChange={onChange} >
                                        <option value="" >Choose an option</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </Select>
                                    <Textarea s={12} m={6}
                                        id={randomNumber()}
                                        name="keywordList"
                                        label="Do you have a list of keywords? If so, please share them."
                                        value={state.keywordList}
                                        onChange={onChange}
                                    />
                                    <Select s={12} m={6}
                                            id={randomNumber()}
                                            name="publicVideo"
                                            label="Do you want us to automatically set your videos to public when we upload?"
                                            value={state.publicVideo}
                                            onChange={onChange} >
                                        <option value="">Choose an option</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </Select>
                                    <Textarea s={12} m={6}
                                        id={randomNumber()}
                                        name="additionalThumbnailData"
                                        label="Anything else you'd like to add?"
                                        value={state.additionalThumbnailData}
                                        onChange={onChange}
                                    />
                                    {/* <div className="thumbnail_row">
                                    <div className="thumbnails_link_div"> */}
                                    <Col s={12} className="description_wrap">
                                        <label>Please provide link(s) to a sample description you like us to base our descriptions off of. You may provide the link to an actual video here. *</label>
                                        <TextInput className="description_link_add_Btn"
                                            icon={<Button  className="btn-primary"
                                                            onClick={()=>addDescriptionLink()}
                                                            ><Icon>add</Icon></Button>}
                                            name="descriptionLink" type="url" validate 
                                            // label="Please provide link(s) to a sample description you like us to base our descriptions off of. You may provide the link to an actual video here. *"
                                            onChange={e => onChangeLinks(e,0)} value={state.descriptionLink[0]}/>
                                        {makeLinks("descriptionLink", state.descriptionLink,removeDescriptionLink )}
                                    {/* </div>
                                    </div> */}
                                    <div id="descriptionLink-error-msg" className="error-hidden">
                                        <MdErrorOutline style = {{ float : 'left' ,marginTop : '-2px' ,marginRight:'5px'}} size = '25px' />
                                        Description Link is required
                                    </div>
                                    </Col>

                                </Row> :null
                            }
                        
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Tab>
                <Tab title="Billing">
                    <BillingTable data={state.billingData || []} />
                </Tab>
                <Tab title="Change Password">
                    <ChangePassword 
                        loggedInUser={loggedInUser}
                        client_id={state.SelectedUserId}
                    />
                </Tab>
            </Tabs>
        </Card>
    );
});

function mapStateToProps({auth}) {
    return {auth};
}
